export default __webpack_public_path__ + "static/textAndImages_cloud_bottom-44f5662c9f19d2cf056bc62d1e0da207.webp";